/*
 * Copyright (c) 2020. Denis Rendler <connect@rendler.me>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import PropTypes from 'prop-types';

const Block = ({ classes, attrs, children }) => {

  return (
    <div className={classes.join(' ')} {...attrs}>
      {children != null ? children : <p>This is an empty block!</p>}
    </div>
  );
};

Block.propTypes = {
  classes:  PropTypes.array,
  attrs:    PropTypes.object,
  children: PropTypes.any,
};

Block.defaultProps = {
  classes:  [],
  attrs:    {},
  children: null,
};

export default Block;
